import { 
  ADD_FACULTY_STRUCTURE,
  ADD_FACULTY_STRUCTURE_ERROR,
  ADD_FACULTY_STRUCTURE_SUCCESS,
  ADD_SPECIALITY_STRUCTURE,
  ADD_SPECIALITY_STRUCTURE_ERROR,
  ADD_SPECIALITY_STRUCTURE_SUCCESS,
  ADD_UNIVERSITY_STRUCTURE,
  ADD_UNIVERSITY_STRUCTURE_ERROR,
  ADD_UNIVERSITY_STRUCTURE_SUCCESS,
  DELETE_FACULTY_STRUCTURE,
  DELETE_FACULTY_STRUCTURE_ERROR,
  DELETE_FACULTY_STRUCTURE_SUCCESS,
  DELETE_SPECIALITY_STRUCTURE,
  DELETE_SPECIALITY_STRUCTURE_ERROR,
  DELETE_SPECIALITY_STRUCTURE_SUCCESS,
  DELETE_UNIVERSITY_STRUCTURE,
  DELETE_UNIVERSITY_STRUCTURE_ERROR,
  DELETE_UNIVERSITY_STRUCTURE_SUCCESS,
  APPROVED_FACULTY_STRUCTURE,
  APPROVED_FACULTY_STRUCTURE_ERROR,
  APPROVED_FACULTY_STRUCTURE_SUCCESS,
  APPROVED_SPECIALITY_STRUCTURE,
  APPROVED_SPECIALITY_STRUCTURE_ERROR,
  APPROVED_SPECIALITY_STRUCTURE_SUCCESS,
  APPROVED_UNIVERSITY_STRUCTURE,
  APPROVED_UNIVERSITY_STRUCTURE_ERROR,
  APPROVED_UNIVERSITY_STRUCTURE_SUCCESS,
  EDIT_FACULTY_STRUCTURE,
  EDIT_FACULTY_STRUCTURE_ERROR,
  EDIT_FACULTY_STRUCTURE_SUCCESS,
  EDIT_SPECIALITY_STRUCTURE,
  EDIT_SPECIALITY_STRUCTURE_ERROR,
  EDIT_SPECIALITY_STRUCTURE_SUCCESS,
  EDIT_UNIVERSITY_STRUCTURE,
  EDIT_UNIVERSITY_STRUCTURE_ERROR,
  EDIT_UNIVERSITY_STRUCTURE_SUCCESS,
  GET_FACULTIES_STRUCTURES, 
  GET_FACULTIES_STRUCTURES_ERROR, 
  GET_FACULTIES_STRUCTURES_SUCCESS, 
  GET_SPECIALITIES_STRUCTURES, 
  GET_SPECIALITIES_STRUCTURES_ERROR, 
  GET_SPECIALITIES_STRUCTURES_SUCCESS, 
  GET_UNIVERSITIES_STRUCTURES, 
  GET_UNIVERSITIES_STRUCTURES_ERROR, 
  GET_UNIVERSITIES_STRUCTURES_SUCCESS 
} from 'redux/constants/Structure';

/**
 * GET UNIVERSITIES
 * @returns 
 */
export const getUniversitiesStructures = () => {
  return {
    type: GET_UNIVERSITIES_STRUCTURES,
  }
};

/**
 * GET UNIVERSITIES SUCCESS
 * @param {*} universities 
 * @returns 
 */
export const getUniversitiesStructuresSuccess = (universities) => {
  return {
    type: GET_UNIVERSITIES_STRUCTURES_SUCCESS,
    universities
  }
};

/**
 * GET UNIVERSITIES ERROR
 * @param {*} message 
 * @returns 
 */
export const getUniversitiesStructuresError = (message) => {
  return {
    type: GET_UNIVERSITIES_STRUCTURES_ERROR,
    message
  }
};

/**
 * DELETE UNIVERSITY
 * @returns 
 */
export const deleteUniversityStructure = (id, cb = () => {}) => {
  return {
    type: DELETE_UNIVERSITY_STRUCTURE,
    payload: {
      id,
      cb
    }
  }
};

/**
 * DELETE UNIVERSITY SUCCESS
 * @returns 
 */
export const deleteUniversityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: DELETE_UNIVERSITY_STRUCTURE_SUCCESS,
  }
};

/**
 * DELETE UNIVERSITY ERROR
 * @returns 
 */
export const deleteUniversityStructureError = (data, cb = () => {}) => {
  return {
    type: DELETE_UNIVERSITY_STRUCTURE_ERROR,
  }
};

/**
 * APPROVED UNIVERSITY
 * @returns 
 */
 export const approvedUniversityStructure = (id, approved, cb = () => {}) => {
  return {
    type: APPROVED_UNIVERSITY_STRUCTURE,
    payload: {
      id,
      approved,
      cb
    }
  }
};

/**
 * APPROVED UNIVERSITY SUCCESS
 * @returns 
 */
export const approvedUniversityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: APPROVED_UNIVERSITY_STRUCTURE_SUCCESS,
  }
};

/**
 * APPROVED UNIVERSITY ERROR
 * @returns 
 */
export const approvedUniversityStructureError = (data, cb = () => {}) => {
  return {
    type: APPROVED_UNIVERSITY_STRUCTURE_ERROR,
  }
};

/**
 * ADD UNIVERSITY
 * @returns 
 */
export const addUniversityStructure = (data, cb = () => {}) => {
  return {
    type: ADD_UNIVERSITY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD UNIVERSITY SUCCESS
 * @returns 
 */
export const addUniversityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_UNIVERSITY_STRUCTURE_SUCCESS,
  }
};

/**
 * ADD UNIVERSITY ERROR
 * @returns 
 */
export const addUniversityStructureError = (data, cb = () => {}) => {
  return {
    type: ADD_UNIVERSITY_STRUCTURE_ERROR,
  }
};

/**
 * EDIT UNIVERSITY
 * @returns 
 */
export const editUniversityStructure = (data, cb = () => {}) => {
  return {
    type: EDIT_UNIVERSITY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT UNIVERSITY SUCCESS
 * @returns 
 */
export const editUniversityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_UNIVERSITY_STRUCTURE_SUCCESS,
  }
};

/**
 * EDIT UNIVERSITY ERROR
 * @returns 
 */
export const editUniversityStructureError = (data, cb = () => {}) => {
  return {
    type: EDIT_UNIVERSITY_STRUCTURE_ERROR,
  }
};

/**
 * GET FACULTIES
 * @returns 
 */
export const getFacultiesStructures = () => {
  return {
    type: GET_FACULTIES_STRUCTURES,
  }
};

/**
 * GET FACULTIES SUCCESS
 * @param {*} faculties 
 * @returns 
 */
export const getFactultiesStructuresSuccess = (faculties) => {
  return {
    type: GET_FACULTIES_STRUCTURES_SUCCESS,
    faculties
  }
};

/**
 * GET FACULTIES ERROR
 * @param {*} message 
 * @returns 
 */
export const getFacultiesStructuresError = (message) => {
  return {
    type: GET_FACULTIES_STRUCTURES_ERROR,
    message
  }
};

/**
 * DELETE Faculty
 * @returns 
 */
export const deleteFacultyStructure = (id, cb = () => {}) => {
  return {
    type: DELETE_FACULTY_STRUCTURE,
    payload: {
      id,
      cb
    }
  }
};

/**
 * DELETE FACULTY SUCCESS
 * @returns 
 */
export const deleteFacultyStructureSuccess = (data, cb = () => {}) => {
  return {
    type: DELETE_FACULTY_STRUCTURE_SUCCESS,
  }
};

/**
 * DELETE FACULTY ERROR
 * @returns 
 */
export const deleteFacultyStructureError = (data, cb = () => {}) => {
  return {
    type: DELETE_FACULTY_STRUCTURE_ERROR,
  }
};

/**
 * APPROVED Faculty
 * @returns 
 */
 export const approvedFacultyStructure = (id, approved, cb = () => {}) => {
  return {
    type: APPROVED_FACULTY_STRUCTURE,
    payload: {
      id,
      approved,
      cb
    }
  }
};

/**
 * APPROVED FACULTY SUCCESS
 * @returns 
 */
export const approvedFacultyStructureSuccess = (data, cb = () => {}) => {
  return {
    type: APPROVED_FACULTY_STRUCTURE_SUCCESS,
  }
};

/**
 * APPROVED FACULTY ERROR
 * @returns 
 */
export const approvedFacultyStructureError = (data, cb = () => {}) => {
  return {
    type: APPROVED_FACULTY_STRUCTURE_ERROR,
  }
};

/**
 * ADD FACULTY
 * @returns 
 */
export const addFacultyStructure = (data, cb = () => {}) => {
  return {
    type: ADD_FACULTY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD FACULTY SUCCESS
 * @returns 
 */
export const addFacultyStructureSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_FACULTY_STRUCTURE_SUCCESS,
  }
};

/**
 * ADD FACULTY ERROR
 * @returns 
 */
export const addFacultyStructureError = (data, cb = () => {}) => {
  return {
    type: ADD_FACULTY_STRUCTURE_ERROR,
  }
};

/**
 * EDIT FACULTY
 * @returns 
 */
export const editFacultyStructure = (data, cb = () => {}) => {
  return {
    type: EDIT_FACULTY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT FACULTY SUCCESS
 * @returns 
 */
export const editFacultyStructureSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_FACULTY_STRUCTURE_SUCCESS,
  }
};

/**
 * EDIT FACULTY ERROR
 * @returns 
 */
export const editFacultyStructureError = (data, cb = () => {}) => {
  return {
    type: EDIT_FACULTY_STRUCTURE_ERROR,
  }
};

/**
 * GET SPECIALITIES
 * @returns 
 */
export const getSpecialitiesStructures = () => {
  return {
    type: GET_SPECIALITIES_STRUCTURES,
  }
};

/**
 * GET SPECIALITIES SUCCESS
 * @param {*} specialities 
 * @returns 
 */
export const getSpecialitiesStructuresSuccess = (specialities) => {
  return {
    type: GET_SPECIALITIES_STRUCTURES_SUCCESS,
    specialities
  }
};

/**
 * GET SPECIALITIES ERROR
 * @param {*} message 
 * @returns 
 */
export const getSpecialitiesStructuresError = (message) => {
  return {
    type: GET_SPECIALITIES_STRUCTURES_ERROR,
    message
  }
};

/**
 * DELETE Speciality
 * @returns 
 */
export const deleteSpecialityStructure = (id, cb = () => {}) => {
  return {
    type: DELETE_SPECIALITY_STRUCTURE,
    payload: {
      id,
      cb
    }
  }
};

/**
 * DELETE SPECIALITY SUCCESS
 * @returns 
 */
export const deleteSpecialityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: DELETE_SPECIALITY_STRUCTURE_SUCCESS,
  }
};

/**
 * DELETE SPECIALITY ERROR
 * @returns 
 */
export const deleteSpecialityStructureError = (data, cb = () => {}) => {
  return {
    type: DELETE_SPECIALITY_STRUCTURE_ERROR,
  }
};

/**
 * APPROVED Speciality
 * @returns 
 */
 export const approvedSpecialityStructure = (id, approved, cb = () => {}) => {
  return {
    type: APPROVED_SPECIALITY_STRUCTURE,
    payload: {
      id,
      approved,
      cb
    }
  }
};

/**
 * APPROVED SPECIALITY SUCCESS
 * @returns 
 */
export const approvedSpecialityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: APPROVED_SPECIALITY_STRUCTURE_SUCCESS,
  }
};

/**
 * APPROVED SPECIALITY ERROR
 * @returns 
 */
export const approvedSpecialityStructureError = (data, cb = () => {}) => {
  return {
    type: APPROVED_SPECIALITY_STRUCTURE_ERROR,
  }
};

/**
 * ADD SPECIALITY
 * @returns 
 */
export const addSpecialityStructure = (data, cb = () => {}) => {
  return {
    type: ADD_SPECIALITY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD SPECIALITY SUCCESS
 * @returns 
 */
export const addSpecialityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_SPECIALITY_STRUCTURE_SUCCESS,
  }
};

/**
 * ADD SPECIALITY ERROR
 * @returns 
 */
export const addSpecialityStructureError = (data, cb = () => {}) => {
  return {
    type: ADD_SPECIALITY_STRUCTURE_ERROR,
  }
};

/**
 * EDIT SPECIALITY
 * @returns 
 */
export const editSpecialityStructure = (data, cb = () => {}) => {
  return {
    type: EDIT_SPECIALITY_STRUCTURE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT SPECIALITY SUCCESS
 * @returns 
 */
export const editSpecialityStructureSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_SPECIALITY_STRUCTURE_SUCCESS,
  }
};

/**
 * EDIT SPECIALITY ERROR
 * @returns 
 */
export const editSpecialityStructureError = (data, cb = () => {}) => {
  return {
    type: EDIT_SPECIALITY_STRUCTURE_ERROR,
  }
};